const Experience=()=>(
    <div className="tab-contents" id="experience">
        <ul>
          {/* <li>
            <span>May 2023-current</span>
            <br />
            Designing Web/App interfaces
          </li> */}
          <li>
            <span>May 2023</span>
            <br />
            Building my own portfolio using React to showcase my profesionnel expertise.
          </li>
          <li>
            <span>May 2023</span>
            <br />
            Building a website for a library to help the organization process using React.
          </li>
          <li>
            <span>June 2023</span>
            <br />
            Developing a website for a startup having two languages Arabe and English and making it responsive using react.
          </li>
          <li>
            <span>July 2023</span>
            <br />
            Currently developing a mobile application for an e-commerce using Flutter and Odoo.
          </li>
        </ul>
      </div>
)
export default Experience;